module.exports = __webpack_public_path__ + "img/hack_2.d628ff91.png";